export default "__VITE_PUBLIC_ASSET__82f75504__"